export const NotFound = () => {
    return (
        <main className="main not-found"></main>
    );
};